import * as React from 'react';

import { EyeIcon, EyeOffIcon } from 'lucide-react';

import { cn } from '../../utils/cn.js';

import { Button } from './button.jsx';

const PasswordInput = React.forwardRef(
  ({ className, variant, disabled, ...props }, ref) => {
    const variants = {
      portal: 'border-portal-foreground h-[46px] rounded-2xl',
    };

    const [showPassword, setShowPassword] = React.useState(false);

    return (
      <div
        className={cn(
          'flex h-10 w-full items-center rounded-md border border-input !bg-background px-3 py-2 text-sm',
          variants[variant],
          className,
        )}
      >
        <input
          type={showPassword ? 'text' : 'password'}
          className="w-[94%] ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-75"
          disabled={disabled}
          {...props}
          ref={ref}
        />

        <Button
          type="button"
          size="icon"
          variant="ghost"
          disabled={disabled}
          className="ml-1.5 size-4 rounded-md text-muted-foreground"
          onClick={() => setShowPassword((prev) => !prev)}
        >
          {showPassword ? <EyeIcon size={18} /> : <EyeOffIcon size={18} />}
        </Button>
      </div>
    );
  },
);
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
